import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const StoreviewGlyph = /*#__PURE__*/createElement("g", {
  id: "SvD"
}, /*#__PURE__*/createElement("path", {
  d: "M74.57,16H9.43 c-0.78,0-1.42,0.63-1.42,1.42v49.17c0,0.78,0.63,1.42,1.42,1.42h65.14c0.78,0,1.42-0.63,1.42-1.42V17.42 C75.99,16.63,75.35,16,74.57,16z M40.61,24.44v18.61H11.44V24.44H40.61z M43.39,24.44h29.17v18.61H43.39V24.44z M11.44,45.83h29.17 v18.89H11.44V45.83z M43.39,64.72V45.83h29.17v18.89H43.39z",
  strokeWidth: "0.255",
  strokeMiterlimit: "10"
}));
const Storeview = createSvg({
  name: 'storeview',
  path: StoreviewGlyph
});

export default Storeview;
export { StoreviewGlyph };
